import { Injectable } from "@angular/core"
import { DisplayDataResolver } from "@pl/pl-lib/common"
import { isEmpty } from "lodash"
import { Country } from "../../models/country"

@Injectable({
  providedIn: "root",
})
export class CountryDisplayDataResolver
  implements DisplayDataResolver<Country>
{
  typeDisplayName = "Country"

  constructor() {}

  getIcon(entity: Country): string | undefined {
    return "k-i-inherited"
  }

  getImage(entity: Country): string | undefined {
    return undefined
  }

  getSubTitle(entity: Country): string | undefined {
    return undefined
  }

  getTitle(entity: Country): string {
    return entity.name
  }

  getShortTitle(entity: Country): string {
    return entity.id
  }

  getItemHref(entityOrID: Country | string): string | undefined {
    if (isEmpty(entityOrID)) {
      return "/app/country"
    }
    if (typeof entityOrID === "string") return "/app/country/" + entityOrID
    return "/app/country/" + entityOrID.id
  }
}
